import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { apiClient } from "../utils/const";

const DeletePayment = ({ pId, userName, onDeleteSuccess, cardNo = "" }) => {
  const [schemeType, setSchemeType] = useState(localStorage.getItem("schemeType"));

  // Listen for scheme changes
  useEffect(() => {
    const handleSchemeChange = (event) => {
      const newScheme = event.detail.to;
      setSchemeType(newScheme);
    };

    window.addEventListener("schemeChanged", handleSchemeChange);
    return () => window.removeEventListener("schemeChanged", handleSchemeChange);
  }, []);

  const endpoint =
    schemeType === "mandal"
      ? "/mandal/delete_mandal_payment.php"
      : "/kanchan/delete_kanchan_payment.php";

  const handleDelete = () => {
    Swal.fire({
      title: `Delete transaction for ${userName}?`,
      text: `This will remove the transaction (ID: ${pId}) permanently.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .post(endpoint, { pId: pId, card_no: cardNo })
          .then((res) => {
            if (res.data.message === "radha") {
              onDeleteSuccess(pId);
              Swal.fire("Deleted!", "Transaction has been deleted.", "success");
            } else {
              Swal.fire("Something went wrong.", "error");
            }
          })
          .catch(() => {
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  return (
    <button
      type="button"
      className="btn btn-outline-danger btn-sm"
      title="Delete Payment"
      onClick={handleDelete}
      style={{
        borderRadius: "8px",
        padding: "6px 12px",
        transition: "all 0.2s ease",
        border: "1px solid #dc3545",
        color: "#dc3545",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#dc3545";
        e.currentTarget.style.color = "white";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(220, 53, 69, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
        e.currentTarget.style.color = "#dc3545";
        e.currentTarget.style.transform = "translateY(0px)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <i className="fas fa-trash" style={{ fontSize: "0.8rem" }}></i>
    </button>
  );
};

export default DeletePayment;
